import React from 'react';
import { inject, observer} from 'mobx-react';
import {WeaTop, WeaTab,WeaRightMenu,WeaErrorPage,WeaSearchGroup,WeaFormItem,WeaSelect,WeaAlertPage,} from 'ecCom';
import {Button, Spin} from 'antd';
import {routerShape} from 'react-router';
import * as mobx from 'mobx';
const toJS = mobx.toJS;
import {WeaTableNew,WeaSwitch} from 'comsMobx';
import {i18n} from '../../public/i18n';
const WeaTable = WeaTableNew.WeaTable;
let _this;

@inject('hrmRpSubSearch')
@observer
class RpSubSearch extends React.Component {
  static contextTypes = {
    router: routerShape
  }

  constructor(props) {
    super(props);
    _this = this;
    const funcs = ['jumpToReport'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }

  componentDidMount() {
    const { hrmRpSubSearch } = this.props;
    hrmRpSubSearch.getHasRight();
  }

  componentWillReceiveProps(nextProps) {
    const { hrmRpSubSearch } = this.props;
    if(this.props.location.key !== nextProps.location.key){
      hrmRpSubSearch.getHasRight();
    }
  }

  render(){
    const { hrmRpSubSearch } = this.props;
    const {title,form,table,showSearchAd,searchParamsAd,verified,hasRight} = hrmRpSubSearch;

    if (verified && hasRight) {
      const formParams = form.getFormParams();
      let loadingTable = table.loading;
      return (
        <div className='wea-myhrm-RpSubSearch'>
        <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
          <WeaTop
            title={title()}
            loading={loadingTable}
            icon={<i className='icon-coms-hrm' />}
            iconBgcolor='#217346'
            buttons={[]}
            buttonSpace={10}
            showDropIcon={false}
          >
          <WeaTab
            buttonsAd={this.getTabButtonsAd()}
            searchType={['base','advanced']}
            searchsBaseValue={formParams.formlabel}
            setShowSearchAd={bool => {hrmRpSubSearch.setShowSearchAd(bool)}}
            hideSearchAd={() => hrmRpSubSearch.setShowSearchAd(false)}
            searchsAd={this.getSearchs()}
            showSearchAd={showSearchAd}
            onSearch={v => {hrmRpSubSearch.doSearch()}}
            advanceHeight={150}
            onSearchChange={v => {
              form.updateFields({
                  formlabel:{name:'formlabel',value:v},
                });
              }}
          />
          <Spin spinning={loadingTable}>
            <WeaTable
              comsWeaTableStore={table}
              hasOrder={true}
              needScroll={true}
              getColumns={c=>this.reRenderColumns(c)}
              />
          </Spin>
          </WeaTop>
          </WeaRightMenu>
        </div>
      );
    }
    if (verified && !hasRight) {
        return (<WeaAlertPage >
                <div style={{color : '#000'}}>
                    {i18n.message.authFailed()}
                </div>
            </WeaAlertPage>
        )
    }
    return (
        <div></div>
    )
  }

  getSearchs() {
    const { hrmRpSubSearch } = this.props;
    const { form,condition } = hrmRpSubSearch;
    const {isFormInit} = form;
    let group = [];
    const formParams = form.getFormParams();
    isFormInit && toJS(condition).map(c =>{
      let items = [];
      c.items.map(fields => {
        let dom =  <WeaSwitch fieldConfig={fields} form={form} formParams={formParams}/>;
        items.push({
          com:(<WeaFormItem
              label={`${fields.label}`}
              labelCol={{span: `${fields.labelcol}`}}
              wrapperCol={{span: `${fields.fieldcol}`}}>
                {dom}
              </WeaFormItem>),
          colSpan:1,
        })
      });
      group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
    });
    return group;
  }

  reRenderColumns(columns){
    columns.forEach(c=>{
        if(c.dataIndex=='formlabel'){
          c.render = function(text, record){
              return  <span style={{cursor:'pointer'}} className='wea-hrm-linkstyle' onClick={_this.jumpToReport.bind(null,record.randomFieldId)}>{record.formlabel}</span>
            }
        } else {
          c.render = function(text, record){
              let valueSpan = record[c.dataIndex + "span"] !== undefined ? record[c.dataIndex + "span"] : record[c.dataIndex];
              return <span dangerouslySetInnerHTML={{__html: valueSpan}}></span>
            }
        }
    })
    return columns;
  }

  jumpToReport(scopeId,...rest){
    let {router} = this.context;
    if (router) {
      router.push({
          pathname: `/main/hrm/constrpsubsearch/${scopeId}`,
          query: {isCustom: "1"}
      });
    }
  }

  getRightMenu(){
    const keys = this.getSelectedRowKeys();
    const arr = [{
        icon: <i className='icon-coms-ws'/>,
        content:i18n.button.search()
      }, {
        icon: <i className='icon-coms-task-list'/>,
        content:i18n.button.columnVisibleSetting()
      }
    ];
    return arr;
  }

  onRightMenuClick(key){
    const { hrmRpSubSearch } = this.props;
    switch(key){
        case '0':
            hrmRpSubSearch.doSearch();
            break;
        case '1':
            this.definedColumn();
            break;
    }
  }

  getSelectedRowKeys(){
    const { hrmRpSubSearch } = this.props;
    const { table} = hrmRpSubSearch;
    const selectedRowKeys = table.selectedRowKeys;
    return selectedRowKeys;
  }

  definedColumn() {
    const { hrmRpSubSearch } = this.props;
    const { table} = hrmRpSubSearch;
    table.setColSetVisible(true);
    table.tableColSet(true);
  }

  getTabButtonsAd() {
    const { hrmRpSubSearch } = this.props;
    const { form,searchParamsAd } = hrmRpSubSearch;
    return [
        (<Button type="primary" onClick={()=>{hrmRpSubSearch.doSearch();hrmRpSubSearch.setShowSearchAd(false)}}>{i18n.button.search()}</Button>),
        (<Button type="ghost" onClick={()=>{form.reset();}}>{i18n.button.reset()}</Button>),
        (<Button type="ghost" onClick={()=>{hrmRpSubSearch.setShowSearchAd(false)}}>{i18n.button.cancel()}</Button>)
    ]
  }
}

export default RpSubSearch


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/report/RpSubSearch.js